import { gql } from '@apollo/client';

export const LIST_IMPORT_CSV_JOBS = gql`
  query ListImportCsvJobs($limit: Int, $nextToken: String) {
    listImportCsvJobs(limit: $limit, nextToken: $nextToken) {
      items {
        jobId
        status
        createdAt
        updatedAt
        completedAt
        s3Key
        totalRecords
        processed
        progressPercent
        failureError
        failureCause
        stats {
          totalRows
          saved
          counters {
            section
            key
            label
            value
          }
          llm {
            byModel {
              model
              input
              cached
              output
              total
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const GET_CSV_SCHEMA = gql`
  query GetCsvSchema {
    getCsvSchema {
      description
      columns {
        name
        label
        required
        description
        examples
      }
    }
  }
`;

export const GET_CSV_EXAMPLE = gql`
  query GetCsvExample {
    getCsvExample
  }
`;

export const GET_CSV_DOWNLOAD_URL = gql`
  query GetCsvDownloadUrl($jobId: ID!) {
    getCsvDownloadUrl(jobId: $jobId)
  }
`;
